import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import { APPLICATION_DETAILS, DOCUMENT_TYPE, OTHER_APPLICATION_DETAILS } from "tagTypes";

export const useLazyGetOtherUtilityApplicationsQuery = () => {
  const [getOtherApplications, data] = useLazyGetQuery();
  const applications = async (query = {}) =>
    await getOtherApplications(
      {
        endpoint: "/other-utility-application",
        query,
        tags: [OTHER_APPLICATION_DETAILS],
      },
      true
    ).unwrap();
  return [applications, data];
};

export const useGetOtherApplicationDetailQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/other-utility-application/id",
    query,
    tags: [OTHER_APPLICATION_DETAILS],
  });

export const useGetOtherApplicationMeterDetailsQuery = (meterId) =>
  useGetQuery({
    endpoint: `/other-utility-meter/${meterId}`,
    tags: [OTHER_APPLICATION_DETAILS],
  });

export const useLazyGetOtherApplicationDetailQuery = () => {
  const [applicationDetails, data] = useLazyGetQuery();
  const applicationDetail = async (query = {}) =>
    await applicationDetails(
      {
        endpoint: "/other-utility-application/id",
        query,
        tags: [OTHER_APPLICATION_DETAILS],
      },
      true
    ).unwrap();
  return [applicationDetail, data];
};

export const useLazyGetOtherApplicationMeterDetailsQuery = () => {
  const [getMeterData, data] = useLazyGetQuery();
  const getMeterDetails = async (meterId) =>
    await getMeterData(
      {
        endpoint: `/other-utility-meter/${meterId}`,
        tags: [OTHER_APPLICATION_DETAILS],
      },
      true
    ).unwrap();
  return [getMeterDetails, data];
};

export const usePostOtherUtilityApplicationDetailsMutation = () => {
  const [applicationDetails, data] = usePostMutation();
  const applicationDetail = async (payload, query = {}) =>
    await applicationDetails({
      endpoint: "other-utility-application",
      query,
      payload: payload || {},
      toastMessage: "Application request added successfully",
      tags: [OTHER_APPLICATION_DETAILS, DOCUMENT_TYPE, APPLICATION_DETAILS],
    }).unwrap();
  return [applicationDetail, data];
};
